import React, { useState, useEffect } from "react";
import Header from "./Header";
import ExamHeader from "./ExamHeader";
import QuestionSection from "./QuestionSection";
import Sidebar from "./Sidebar";
import { useQuestion } from "../../../context/QuestionsContext";
import { useQuestionRecord } from "../../../context/QuestionRecord";
import { useQuestionSection } from "../../../hooks/default/useQuestionSection";
import SubmissionPopupReLogin from "../../../components/popups/SubmissionPopupReLogin";
import SubmissionPopup from "../../../components/popups/SubmissionPopup";
import ServerErrorDialog from "../../../components/popups/ServerErrorDialog";
import FinalSubmissionDialog from "../../../components/popups/FinalSubmissionDialog";
import {
  Typography,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Drawer,
  FormControl,
  Select,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import oip from "../../../images/OIP.jpeg";
import { decryptData } from "../../../crypto";
import { useLanguages } from "../../../context/LanguagesContext";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton as MuiIconButton } from "@mui/material";

function FeedbackTest() {
  const { question } = useQuestion();
  const { questionRecords } = useQuestionRecord();

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentQuestionBySubject, setCurrentQuestionBySubject] = useState(0);
  const [currentSubject, setCurrentSubject] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openInstructions, setOpenInstructions] = useState(false);
  const { languages, handleChange, selectedLanguage } = useLanguages();

  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleOpenInstructions = () => setOpenInstructions(true);
  const handleCloseInstructions = () => setOpenInstructions(false);

  const questionData = question?.subjects
    ?.map((subject) => subject?.questions)
    .flat();


  const [expandedSubject, setExpandedSubject] = useState(null);

  // Toggle expand/collapse
  const toggleSubject = (name) => {
    setExpandedSubject((prev) => (prev === name ? null : name));
  };

  const subjects = question?.subjects;

  const {
    selectedOptionId,
    showSubmissionPopup,
    showSubmissionPopupReLogin,
    showServerErrorDialog,
    setShowServerErrorDialog,
    showSubmitModal,
    isTimeUp,
    setIsTimeUp,
    countdownTime,
    finalSubmitChecked,
    submitError,
    countdownByHead,
    stats,
    handleOptionChange,
    handleMultipleChoiceChange,
    handleInputChange,
    resetSelections,
    handleSaveNextDefault,
    handleMarkReviewDefault,
    handleClearResponse,
    handleBack,
    handleSave,
    handleNext,
    handleOpenSubmitModal,
    handleCloseSubmitModal,
    handleFinalSubmitCheck,
    handleFinalSubmit,
    setOpenMandatory,
    openMandatory,
  } = useQuestionSection({

    questionData,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
  });

  useEffect(() => {
    if (question) {
      setCurrentSubject(question?.subjects[0].subject_name);
      setExpandedSubject(question?.subjects[0].subject_name)
      setSubjectId(question?.subjects[0].id);
    }
  }, [question]);

  // const preTotal = (subjectId) => {
  //   if (!Array.isArray(subjects) || subjects.length === 0) return false;

  //   const index = subjects.findIndex(
  //     (subject) => Number(subject.id) === Number(subjectId)
  //   );
  //   if (index <= 0) return false; // if first subject or not found

  //   const total = subjects
  //     .slice(0, index)
  //     .reduce((sum, subj) => sum + (subj.subject_question_count || 0), 0);

  //   return total === currentQuestion;
  // };

  // useEffect(() => {
  //   if (!questionData?.[currentQuestion] || !Array.isArray(subjects)) return;

  //   const currentQSubjectId = questionData[currentQuestion].subject_id;
  //   const foundSubject = subjects.find(
  //     (s) => Number(s.id) === Number(currentQSubjectId)
  //   );

  //   if (!foundSubject) return;

  //   if (foundSubject.subject_name !== currentSubject) {
  //     if (preTotal(foundSubject.id)) {
  //       setCurrentQuestionBySubject(foundSubject.subject_question_count);
  //     } else {
  //       setCurrentQuestionBySubject(0);
  //     }

  //     setCurrentSubject(foundSubject.subject_name);
  //   }
  // }, [currentQuestion, questionData, subjects, currentSubject]);

  useEffect(() => {
    if (questionData && subjects) {
      const currentSubjectId = questionData[currentQuestion]?.subject_id;
      const subjectIndex = subjects.findIndex(
        (s) => Number(s.id) === Number(currentSubjectId)
      );

      if (subjectIndex === -1) return;

      // Subject ke pehle ke saare questions ka count (offset)
      const offset = subjects
        .slice(0, subjectIndex)
        .reduce((sum, s) => sum + (s.subject_question_count || 0), 0);

      // Within-subject index = global index - offset
      const withinSubjectIndex = currentQuestion - offset;
      setCurrentQuestionBySubject(withinSubjectIndex);

      const foundSubject = subjects[subjectIndex];
      if (foundSubject.subject_name !== currentSubject) {
        setCurrentSubject(foundSubject.subject_name);
        setExpandedSubject(foundSubject.subject_name);
        setSubjectId(foundSubject.id); // update subjectId when subject changes
      }
    }
  }, [currentQuestion]);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  // Wrapper: check ALL questions attempted before opening submit modal
  const handleOpenSubmitModalWithCheck = () => {
    const isMandatory = sessionStorage.getItem("exam_type") === "demo";
    if (isMandatory && questionData) {
      // NOTE: current question's record is not yet in `questionRecords` (React state update is async).
      // It was already validated as answered by handleSaveNextDefault, so we skip it here.
      const currentQuestionId = Number(questionData[currentQuestion]?.id);
      const allAttempted = questionData.every((q) => {
        if (Number(q.id) === currentQuestionId) {
          return true; // current question already passed save validation
        }
        const record = questionRecords?.find(
          (r) => Number(r.question_id) === Number(q.id)
        );
        return record && record.attempt_status && record.attempt_status !== "not answered";
      });
      if (!allAttempted) {
        setOpenMandatory(true);
        return;
      }
    }
    handleOpenSubmitModal(true);
  };

  const sidebarContent = (
    <Sidebar
      subjects={subjects}
      setCurrentQuestion={(idx) => {
        setCurrentQuestion(idx);
        setMobileOpen(false);
      }}
      setCurrentSubject={setCurrentSubject}
      setSubjectId={setSubjectId}
      currentQuestion={currentQuestion}
      questionData={questionData}
      setCurrentQuestionBySubject={setCurrentQuestionBySubject}
      expandedSubject={expandedSubject}
      setExpandedSubject={setExpandedSubject}
      toggleSubject={toggleSubject}
      handleOpenInstructions={handleOpenInstructions}
    />
  );

  return (
    <div style={{ overflowX: "hidden", minHeight: "100vh", background: "#f8f9fa" }}>
      <Header
        handleDrawerToggle={handleDrawerToggle}
        handleOpenInstructions={handleOpenInstructions}
        openInstructions={openInstructions}
        handleCloseInstructions={handleCloseInstructions}
      />
      <ExamHeader
        subjectName={currentSubject}
        showSubmitModal={showSubmitModal}
        handleCloseSubmitModal={handleCloseSubmitModal}
        handleFinalSubmit={handleFinalSubmit}
        handleFinalSubmitCheck={handleFinalSubmitCheck}
        isTimeUp={isTimeUp}
        stats={stats}
        setIsTimeUp={setIsTimeUp}
        submitError={submitError}
        countdownTime={countdownTime}
        finalSubmitChecked={finalSubmitChecked}
      />

      {/* Mobile Drawer for sidebar */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: { xs: "80vw", sm: 320 },
            maxWidth: 340,
            boxSizing: "border-box",
          },
        }}
      >
        <Box sx={{ p: 1, height: "100%", overflowY: "auto" }}>
          {sidebarContent}
        </Box>
      </Drawer>

      {/* Main layout: question + sidebar */}
      <Box
        sx={{
          display: "flex",
          borderBottom: "1px solid #e0e0e0",
          width: "100%",
          overflowX: "hidden",
          flex: 1, // Add this to fill available height
        }}
      >
        <QuestionSection
          questionData={questionData}
          currentQuestion={currentQuestion}
          handleOptionChange={handleOptionChange}
          handleSaveNextDefault={handleSaveNextDefault}
          handleMarkReviewDefault={handleMarkReviewDefault}
          handleClearResponse={handleClearResponse}
          selectedOptionId={selectedOptionId}
          handleBack={handleBack}
          currentQuestionBySubject={currentQuestionBySubject}
          setCurrentQuestionBySubject={setCurrentQuestionBySubject}
          handleOpenSubmitModal={handleOpenSubmitModalWithCheck}
        />
        {/* Desktop sidebar */}
        <Box sx={{ display: { xs: "none", md: "block" }, minWidth: 220, maxWidth: "20%" }}>
          {sidebarContent}
        </Box>
      </Box>

      <SubmissionPopupReLogin
        open={showSubmissionPopupReLogin}
        countdown={countdownByHead}
      />

      <SubmissionPopup
        open={showSubmissionPopup}
        countdown={countdownByHead}
        stats={stats}
      />

      <ServerErrorDialog
        open={showServerErrorDialog}
        onClose={() => setShowServerErrorDialog(false)}
      />

      <FinalSubmissionDialog
        open={showSubmitModal || isTimeUp}
        onClose={handleCloseSubmitModal}
        onSubmit={() => {
          if (isTimeUp) {
            handleFinalSubmit("time");
          } else {
            handleFinalSubmit("user");
          }
        }}
        isTimeUp={isTimeUp}
        stats={stats}
        submitError={submitError}
        countdownTime={countdownTime}
        finalSubmitChecked={finalSubmitChecked}
        onFinalSubmitCheck={handleFinalSubmitCheck}
      />

      <Dialog
        open={openMandatory}
        onClose={() => setOpenMandatory(false)}
        PaperProps={{
          sx: {
            width: { xs: "90%", sm: "350px" },
            minWidth: { xs: "unset", sm: "350px" },
            borderRadius: "16px",
            padding: { xs: "12px", sm: "20px" },
            boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          },
        }}
      >
        <Box sx={{ textAlign: "center", pt: 2 }}>
          <img
            src={oip}
            style={{
              height: 50,
              width: 50,
              margin: "auto",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
            }}
            alt="Warning"
          />
        </Box>
        <DialogTitle
          sx={{
            textAlign: "center",
            padding: "8px 24px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem" } }}>
            Warning
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", padding: "8px 24px" }}>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
          >
            All questions are mandatory. Please attempt all of them.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            padding: "16px 24px 24px",
          }}
        >
          <Button
            variant="contained"
            onClick={() => setOpenMandatory(false)}
            sx={{
              minWidth: "120px",
              textTransform: "none",
              backgroundColor: "#1374aa",
              borderRadius: "8px",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#105a8d",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Instructions Dialog (Shared) ── */}
      <Dialog
        open={openInstructions}
        onClose={handleCloseInstructions}
        maxWidth={false}
        fullScreen={isTabletOrMobile}
        PaperProps={{
          style: isTabletOrMobile
            ? {}
            : { width: "80vw", height: "80vh" },
        }}
      >
        <DialogTitle
          sx={{ backgroundColor: "#1374aa", p: 0, overflow: "hidden" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
              color: "white",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.9rem", sm: "1rem" },
                color: "white",
              }}
            >
              Instructions
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FormControl size="small">
                <Select
                  value={selectedLanguage}
                  onChange={handleChange}
                  sx={{
                    minWidth: { xs: 100, sm: 120 },
                    height: 30,
                    fontSize: "0.8rem",
                    background: "white",
                  }}
                >
                  {languages?.map((lang) => (
                    <MenuItem key={lang.value} value={lang.value}>
                      {lang.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <MuiIconButton onClick={handleCloseInstructions} edge="end" size="small">
                <CloseIcon style={{ color: "white" }} />
              </MuiIconButton>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{
            whiteSpace: "pre-line",
            "& img": {
              width: "auto !important",
              maxWidth: "100% !important",
              height: "auto !important",
              display: "block",
              margin: "15px 0",
            },
          }}
        >
          <DialogContentText>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  selectedLanguage === "english"
                    ? decryptData(sessionStorage.getItem("examInstructions"))
                    : decryptData(sessionStorage.getItem("instructionsHindi")),
              }}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default FeedbackTest;
